export default "__VITE_ASSET__7224e483__"